import React from "react";
import { Box, Typography } from "@mui/material";

const PolygonBox = ({ number = 22, color = "#FF0000", width = 30, height = 40,border='none' }) => {
  return (
    <Box
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: color,
        clipPath: "polygon(0 0, 100% 32%, 100% 72%, 0% 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: "bold",
         border:border,
        fontSize: "2rem",
        boxShadow: "2px 2px 6px rgba(0,0,0,0.3)", // optional shadow
        // position: "relative",
      }}
    >
      <Typography
        sx={{
        //   position: "absolute",
        //   top: "50%",
        //   left: "50%",
        //   transform: "translate(-50%, -50%)",
        }}
      >
        {number}
      </Typography>
    </Box>
  );
};

export default PolygonBox;
